module.exports = __webpack_public_path__ + "static/media/Map.0e97ca61.png";